<template>
  <v-card v-if="count > 0 || donthide"
          width="auto"
          :color="color ? color : 'primary'"
          class="rounded-pill white--text card-badge"
          :class="index ? 'notfirst' : ''"
          :style="'z-index: ' + (index ? index : 1) + ' !important;'"
          elevation="0">
    <p class="mb-0 smalltext">{{index > 0 ? '+' : ''}}{{count}}</p>
  </v-card>
</template>

<script>
export default {
  name: "CardBadge",
  props: ["count", "donthide", "color", "index"],
  components: {},

  data() {
    return {};
  },

  created() {},

  mounted() {},

  methods: {},

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped>
.card-badge {
  height: 19px;
  display: flex;
  flex-grow: 0;
  align-items: center;
  min-width: 19px !important;
  padding: 0px 7px !important;
  width: fit-content !important;
}
.card-badge.notfirst {
  min-width: 23px !important;
  margin-left: -5px;
}
.smalltext {
  font-size: 12px !important;
  max-width: auto;
}
.v-expansion-panel-header > *:not(.v-expansion-panel-header__icon) {
  flex-grow: 0;
}
</style>